import React from 'react'

import type { IconSource } from 'components/shared/Icon/Icon'

import { BUTTON, CHIP_GROUP, getContent, ICON_WITH_TEXT, TEXT } from './model'

type ContentProps = {
  children?: React.ReactNode
  chips?: unknown[]
  chipsClassName?: string
  iconClassName?: string
  textClassName?: string
  icon?: IconSource
  size?: number
  type: string
}

export const Content = ({
  children,
  chips,
  chipsClassName,
  iconClassName,
  textClassName,
  icon,
  size = 24,
  type,
}: ContentProps) => {
  const Component = getContent(type)

  const mapContentToProps = {
    [BUTTON]: {},
    [CHIP_GROUP]: { chips, className: chipsClassName },
    [ICON_WITH_TEXT]: { icon, iconClassName, size, textClassName },
    [TEXT]: { className: textClassName },
  }

  if (Component == null) return null

  return <Component {...mapContentToProps[type]}>{children}</Component>
}
